import type { Job } from './job.interface';

export interface cv_JobSubtype {
    C_JobSubtype_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    Job: Job[];
    JobSubtype: string;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
